// External libs
import React, { useState, useEffect } from 'react';
import axiosInstance from '../../utils/axiosInstance.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

// Assets
import './popupPage.css';

// Components
import { route_upload_firmwares} from '../../constants/BackendRoutes.js';

const FirmwareUploadPopupForm = ({ onClose, onSubmit, deviceTypes }) => {
    const [formData, setFormData] = useState({
        file: null,
        deviceType: deviceTypes[0] || '',
        firmwareVersion: ''
    });
    const [uploadProgress, setUploadProgress] = useState(0);
    const [error, setError] = useState('');
    const [firmwareMetadata, setFirmwareMetadata] = useState(null);
    const [progressMsg, setProgressMsg] = useState('');

      // Reset state when popup opens
      useEffect(() => {
          setFormData({
              file: null,
              deviceType: deviceTypes[0] || '',
              firmwareVersion: ''
          });
          setUploadProgress(0);
          setError('');
          setFirmwareMetadata(null);
          setProgressMsg('');
    }, []);

    // Handle file selection
    const handleFileChange = (e) => {
        setFormData({ ...formData, file: e.target.files[0] });
    };

    // Handle input changes
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.file || !formData.deviceType || !formData.firmwareVersion) {
            setError("All fields are required");
            return;
        }
        setError('');
        // Build the URL dynamically with deviceType and firmwareVersion
        const url = `${route_upload_firmwares}/${formData.deviceType}/${formData.firmwareVersion}`;

        const uploadData = new FormData();
        uploadData.append("file", formData.file);

        try {
            const response = await axiosInstance.post(url, uploadData, {
                headers: { 'Content-Type': 'multipart/form-data' },
                onUploadProgress: (progressEvent) => {
                    setUploadProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                }
            });
            // When upload is complete, store metadata and show it
            setFirmwareMetadata(response.data.firmwareMetadata);
            setProgressMsg("Firmware uploaded successfully! Metadata below:"); // Set metadata message
            setUploadProgress(100); // Set progress to 100% when done
            onSubmit(response.data.firmwareMetadata);
        } catch (error) {
            setError("Upload failed. Please try again.");
        }
    };

    return (
        <div className="popup-overlay">
            <div className="popup">
                <div className="popup-header">
                    <span className="popup-title">Upload Firmware</span>
                    <button className="close-btn" onClick={onClose}><FontAwesomeIcon icon={faXmark} /></button>
                </div>
                <form onSubmit={handleSubmit}>
                    <label className='file-label'>
                        {formData.file ? formData.file.name : "Choose File:"}
                        <input type="file" onChange={handleFileChange} required className="file-input"/>
                    </label>

                    <label>
                        Device Type:
                        <select name="deviceType" value={formData.deviceType} onChange={handleChange}>
                            {deviceTypes.map((type, index) => (
                                <option key={index} value={type}>{type}</option>
                            ))}
                        </select>
                    </label>

                    <label>
                        Firmware Version:
                        <input type="text" name="firmwareVersion" value={formData.firmwareVersion} onChange={handleChange} required />
                    </label>

                    {uploadProgress > 0 && uploadProgress < 100 && <p>Upload Progress: {uploadProgress}%</p>}
                    {error && <p className="error">{error}</p>}
                    {progressMsg && (
                        <div>
                            <p className = "success-message">{progressMsg}</p>
                            <ul>
                                <li><strong>Version:</strong> {firmwareMetadata.fw_ver}</li>
                                <li><strong>CRC:</strong> {firmwareMetadata.fw_crc}</li>
                                <li><strong>Size:</strong> {firmwareMetadata.fw_size} bytes</li>
                                <li><strong>Signature:</strong> {firmwareMetadata.fw_sig}</li>
                            </ul>
                        </div>
                    )}
                    <button className="popup-submit-btn" type="submit">Upload</button>
                </form>
            </div>
        </div>
    );
};

export default FirmwareUploadPopupForm;
